const ISO8601_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

export function formatSignature(sig: string): string {
  if (ISO8601_RE.test(sig)) {
    const d = new Date(sig);
    if (!isNaN(d.getTime())) {
      return d.toLocaleString(undefined, {
        month: 'short', day: 'numeric', year: 'numeric',
        hour: 'numeric', minute: '2-digit',
      });
    }
  }
  return sig;
}
